import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Button, Card, TextField, Container, IconButton, MenuItem, Popover, FormControl, InputLabel, Select, Stack, Typography } from '@mui/material'
import Iconify from '../components/iconify';
import { toleranceApproval, fetchWorkList, fetchmanagetolerancelist, addmanagetolerancelist, deletemanagetolerancelist, ByIdFetchmanagetolerance, Editmanagetolerance, getqualitymaterialcode, fetchqualitydetails } from './qualityApi';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import { Add as AddIcon, Clear as CancelIcon, Send as SendIcon, Done as ApproveIcon, Visibility as ViewIcon } from '@mui/icons-material';
import { format } from 'date-fns';
import { ITEM_RATE_MASS_ENTRY } from '../../common/constants';
import { capitalizeFunction, openTextFieldMaxLength, VALIDATION } from '../../common/commonValidations';
import { ConfirmationPopover } from '..//../common/commonPopovers/confirmationPopover';
import { useTranslation } from "react-i18next";

export default function ManageWorkList() {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [WorkListDetails, setWorkListDetails] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
  const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
  const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);
  const [actionText, setActionText] = useState("");
  const [action, setAction] = useState("");

  const onConfirmAction = () => {
    handleLogModalCloseSubmit();
    const updatedArray = selectedRows.map(item => {
      return {
        ...item,
        status: action
      };
    })
    setSelectedRows(updatedArray);
    toleranceApproval(updatedArray, setWorkListDetails, setSelectedRows, navigate)
  }

  const onAction = (actionArg, actionTextArg) => {
    setAction(actionArg);
    setActionText(actionTextArg);
    handleLogModalOpenSubmit();
  }

  const handleChange = (e, row) => {
    const updatedArray = WorkListDetails.map(item => {
      if (item.id === row.id) {
        item.comment = VALIDATION.noSpecialCharacterValidation(e.target.value)
      }
      return item
    })
    setWorkListDetails(updatedArray);
  }

  useEffect(() => {
    fetchWorkList(setWorkListDetails)
  }, []);

  const columns = [{
    field: 'qualityParameter', headerName: 'Quality parameter', width: 150
  },
  {
    field: 'materialCode', headerName: 'Material Code', width: 120
  },
  {
    field: 'toleranceLimit', headerName: 'Tolerance Limit(%)', width: 150,
    renderCell: (params) => {
      return (
        <div>{params?.value === 0 ? '' : params?.value}</div>
      )
    }
  },
  {
    field: 'minValue', headerName: 'Min Value', width: 90
  },
  {
    field: 'maxValue', headerName: 'Max Value', width: 90
  },
  {
    field: 'unitOfMeasurement', headerName: 'UOM', width: 60,
    renderCell: (params) => {
      return (
        <div>{params?.value}</div>
      )
    }
  },
  {
    field: 'createdOn', headerName: 'Created On', width: 120,
    renderCell: (params) => {
      return (
        <div>{format(new Date(params?.value), 'dd/MM/yyyy')}</div>
      )
    }
  },
  {
    field: 'crtdBy', headerName: 'Created By', width: 210
  },
  {
    field: 'operation', headerName: 'Type', width: 100
  },
  {
    field: 'status', headerName: 'Status', width: 100
  },
  {
    field: 'comment', headerName: 'Comment', width: 300,
    renderCell: (params) => {
      return (
        params.row.status === "Open" ?
          <TextField
            fullWidth
            id="outlined-required"
            label={t('reg.comment')}
            inputProps={{
              maxLength: openTextFieldMaxLength,
            }}
            name="Comment"
            size="small"
            onChange={(e) => handleChange(e, params.row)}
            value={params.value}
            sx={{ mt: 1, pb: 1 }}
          /> : <>{params.value}</>
      )
    }
  },
  ]

  const sortModel = [
    {
      field: 'status',
      sort: 'asc',
      sortComparator: (v1, v2, cellParams1, cellParams2) => {
        // Custom sorting function to sort 'open' status rows first
        if (cellParams1.row.status === 'open' && cellParams2.row.status !== 'open') {
          return -1;
        } else if (cellParams1.row.status !== 'open' && cellParams2.row.status === 'open') {
          return 1;
        }
        return v1.toString().localeCompare(v2, 'en', { numeric: true });
      },
    },
  ];

  return (
    <>
      <Container maxWidth="xxl">
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            Tolerance Limit WorkList
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
            <><Stack direction="row" spacing={1}>
              <Button disabled={selectedRows?.length === 0} onClick={() => onAction("Approved", "Approve")} variant="contained" startIcon={<ApproveIcon />}>
                Approve
              </Button>
              <Button disabled={selectedRows?.length === 0} onClick={() => onAction("Rejected", "Reject")} variant="contained" startIcon={<CancelIcon />}>
                Reject
              </Button>
            </Stack></>
          </Stack>
        </Stack>
        <Card>
          <Box style={{ height: 400, width: '100%' }}>
            {<DataGrid
              rows={WorkListDetails ? WorkListDetails : []}
              columns={columns}
              pageSize={5}
              checkboxSelection
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRowData = WorkListDetails?.filter((row) =>
                  selectedIDs.has(row.id.toString())
                )
                setSelectedRows(selectedRowData);
              }}
              isRowSelectable={(params) => params.row.status === "Open"}
              components={{
                Toolbar: CustomDataGridToolbar,
              }}
              componentsProps={{ toolbar: { rows: WorkListDetails ? WorkListDetails : [], columns: columns, fileName: "ToleranceWorkList.xlsx" } }}
            />
            }
          </Box>
        </Card>
      </Container>
      <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmAction} action={actionText} onClose={handleLogModalCloseSubmit} />
    </>
  )
}